/**
 * Class "hydrated" keeps element visible to prevent flash
 * when switching from default content to username.
 */
loyalty-program-username {
	display: inline-block;
}
